import { Group, Model, Prompt, PromptFunction } from '../Types';
import requestClient from '../components/Utility/RequestClient';
import Store from '../Store/Store';

const resolveDemo = () => Store.getState().environment.demoInstance;

export const groupService = {
    saveGroup: async (type: string, data: any): Promise<{ data: Group }> => {
        return requestClient.post<Group>(`/groups/${type}`, data);
    },

    getGroupsByPage: (
        page: number,
        itemsPerPage: number,
        additionalParams?: Record<string, any>,
        query?: string | null,
    ): Promise<{ data: { data: Group[]; total: number } }> => {
        return requestClient
            .get(`${resolveDemo() ? '/demo' : ''}/groups/get`, {
                params: {
                    page,
                    itemsPerPage,
                    query,
                },
            })
            .then((response: any) => response);
    },

    getGroups: async (): Promise<{ data: Group[] }> => {
        return requestClient.get<Group[]>(`${resolveDemo() ? '/demo' : ''}/groups/get`);
    },

    getGroup: async (groupIdentifier: string): Promise<{ data: Group }> => {
        return requestClient.get<Group>(`${resolveDemo() ? '/demo' : ''}/groups/get/${groupIdentifier}`);
    },

    getGroupsByUser: async (userIdentifier: string): Promise<{ data: Group[]; total: number }> => {
        const response = await requestClient.get<{ data: Group[]; total: number }>(
            `${resolveDemo() ? '/demo' : ''}/groups/getbyuser/${userIdentifier}`,
        );
        return response.data;
    },

    getPrompts: async (): Promise<{ data: Prompt[] }> => {
        return requestClient.get<Prompt[]>(`${resolveDemo() ? '/demo' : ''}/prompts/get`);
    },

    getModels: async (): Promise<{ data: Model[] }> => {
        return requestClient.get<Model[]>(`${resolveDemo() ? '/demo' : ''}/settings/allmodels`);
    },

    getFunctions: async (): Promise<{ data: PromptFunction[] }> => {
        return requestClient.get<PromptFunction[]>(`${resolveDemo() ? '/demo' : ''}/promptfunctions/get`);
    },
};
